'use strict';

import React from 'react';

import { OnSchedRest }  from "../../OnSchedRest";
import { OnSchedUtils } from "../../utils";

import Confirmation     from "../../components/Confirmation/Confirmation";
import Title            from "../../components/Title/Title";
import Wizard           from "../../components/Wizard/Wizard";
import { GetResource }  from '../../actions/resourceActions';


const ResourceSetup = element => {
  const [submitted, submit] = React.useState(false);
  const [state, setState] = React.useState({});

  React.useEffect(() => {
    if (element.options.userInterface === false) {
      const handleResponse = response => {
        OnSchedUtils.CheckErrors({element, data: response})
          .then(detail => {
            OnSchedUtils.CustomEvents(element.id, detail.object + 'SetupComplete', detail);
            submit(true);
          })
      }

      const data = element.params;
      if (data.id) delete data.id;

      if (!element.params.id) {
        OnSchedRest.Post(element.onsched.setupApiBaseUrl + '/resources', data, handleResponse)
      }
      else {
        OnSchedRest.Put(element.onsched.setupApiBaseUrl + '/resources/' + element.params.id, data, handleResponse)
      }
    }
    else {
      if (element.params.id) {
        // Update existing
        GetResource(element, element.params.id)
          .then(response => {
            setState(Object.assign(state, { resource: response }))
          })
      }
      else {
        // Create new

      }
    }
  }, []);
  
  
  const onSubmit = values => {
    console.log('', values)
    let weekdays = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
    
    let data = { availability: {} };

    weekdays.map(w => {
      const morningStart = values[`availability.${w}.startTimeMeridiem`] === 'am';
      const morningEnd = values[`availability.${w}.endTimeMeridiem`] === 'am';

      const start = values[`availability.${w}.startTime`];
      const end = values[`availability.${w}.endTime`];

      if (start && end) {
        data.availability[w] = { 
          startTime: morningStart ? parseInt(start) : parseInt(start) + 1200,
          endTime: morningEnd ? parseInt(end) : parseInt(end) + 1200
        }
      }
    })
    
    data.timezoneName = values.timezone;
    data.name = values.name;
    data.email = values.email ? values.email : '';
    data.website = values.website ? values.website : '';
    data.blocks = state.blocks;
    data.availability = {
      mon: {
        startTime: values["availability.mon.startTime"],
        endTime: values["availability.mon.endTime"],
      },
      tue: {
        startTime: values["availability.tue.startTime"],
        endTime: values["availability.tue.endTime"],
      },
      wed: {
        startTime: values["availability.wed.startTime"],
        endTime: values["availability.wed.endTime"],
      },
      thu: {
        startTime: values["availability.thu.startTime"],
        endTime: values["availability.thu.endTime"],
      },
      fri: {
        startTime: values["availability.fri.startTime"],
        endTime: values["availability.fri.endTime"],
      },
      sat: {
        startTime: values["availability.sat.startTime"],
        endTime: values["availability.sat.endTime"],
      },
      sun: {
        startTime: values["availability.sun.startTime"],
        endTime: values["availability.sun.endTime"],
      },
    }

    data.address = {
      addressLine1: values.addressLine1 ? values.addressLine1 : '',
      addressLine2: values.addressLine2 ? values.addressLine2 : '',
      city: values.city ? values.city : '',
      state: values.state ? values.state : '',
      postalCode: values.postalCode ? values.postalCode : '',
    }

    submit(true);
    const blocks = data.blocks;

    const createResourceBlocks = (resourceResponse, block) => new Promise((resolve, reject) => {
      const blockPayload = {
        "locationId": resourceResponse.locationId,
        "startDate": block.startDate,
        "endDate": block.endDate,
        "startTime": block.startTime,
        "endTime": block.endTime,
        "reason": "Time block",
        "repeats": false,
        "repeat": {
          "frequency": "D",
          "interval": 1,
          "weekdays": "",
          "monthDay": block.startDate.slice(8,10),
          "monthType": "D"
        }
      }
      
      OnSchedRest.Post(element.onsched.setupApiBaseUrl + '/resources/' + resourceResponse.id + '/block', blockPayload, blocksResponse => {
        setTimeout(() => {
          resolve(blocksResponse)
        }, 500);
      })
    })

    if (!element.params.id) {
      OnSchedRest.Post(element.onsched.setupApiBaseUrl + '/resources', data, response => {
        let i = 0;
        
        const addBlocks = () => {
          createResourceBlocks(response, blocks[i])
            .then(e => {
              while (i < blocks.length) {
                i += 1;

                if (blocks[i]) {
                  addBlocks();  
                }
                else {
                  OnSchedUtils.Toast(element, { error: false, message: 'Resource created successfully.' })

                  const resourceSetupEvent = new CustomEvent("resourceSetupComplete", { detail: response });
                  document.getElementById(element.id).dispatchEvent(resourceSetupEvent);

                  break;
                };
              }
            })
        };


        addBlocks();
      })
    }
  }

  if (element.options.userInterface === false) {
    return null
  }
  else if (!submitted) {
    return (
      <>
        <Title element={element} title={OnSchedUtils.Internationalize(element, 'setup_resourceSetup_title')}/>
        <Wizard onSubmit={onSubmit} element={element} onschedState={{state, setState}} form="ResourceForm" />
      </>
    )
  }
  else {
    return (
      <Confirmation msg={OnSchedUtils.Internationalize(element, 'setup_resourceSetup_confirmation')} />
    )
  }
}

export default ResourceSetup;
